module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "BHD"
  }, [_vm._v("COVERING CAKES")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Before you can add an amazing floral decoration, you need to know how to cover your cake, making sure that the buttercream sticks to it and provides a clean base. You need to first crumb coat, then create a smooth surface. Further techniques for creating textured or perfectly smooth surfaces can be found within the cake projects at the end of the book.")]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("CRUMB COATING")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This technique means applying a thin layer of buttercream around your cake to secure the loose crumbs. This is a very important step that you should not miss, as this makes your outer layer of buttercream stick to the cake, giving the heavy piped and textured designs something to adhere to.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". You can use a palette knife to apply the buttercream to the cake, but some cake sponges can be very crumbly. When you use a palette knife, the tendency is to keep pushing and pressing the frosting and this might damage your cake. Instead, we use a piping bag to apply the frosting.")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Use a round nozzle or just snip the end off a piping bag. Using the same frosting that will go on the rest of the cake, fill the piping bag ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F1"
    }
  }, [_vm._v("A")]), _vm._v(") and pipe around the cake with a good pressure so it sticks to the cake ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F2"
    }
  }, [_vm._v("B")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("3")]), _vm._v(". Use your palette knife to spread the buttercream, using even pressure ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F3"
    }
  }, [_vm._v("C")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("4")]), _vm._v(". Next you can use a cake scraper to level out the thickness of the frosting and to remove any excess ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F4"
    }
  }, [_vm._v("D")]), _vm._v(").")])]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("SMOOTHING")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("After the cake has been chilled for a short while you can apply another layer of buttercream and create a smooth surface. The thickness of this layer will be a matter of taste. To be able to produce a perfectly smooth a cake takes patience and practise. Trust us, you will not be able to ‘perfectly perfect’ it on your first go, but after a while you will get so practised at it that it will become easy.")]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("PALETTE KNIFE")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This is the common way of smoothing a cake – no fancy tool, just a palette knife. You simply have to spread the buttercream frosting around the cake using the knife. The finish though is not perfectly smooth as the knife will leave a few lines and ridges.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("You can use any palette knife, straight or cranked, and the best choice of size will depend on the size of your cake. We find it is best to use a short crank-handled knife for most occasions. The direction in which you spread doesn’t matter, but it is important to remove any excess buttercream and to make an even layer ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F5"
    }
  }, [_vm._v("A")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "F5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F35.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("CAKE SCRAPER")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Make sure that the edge of your scraper is perfectly smooth. Remember that any dent on your scraper will be visible on your cake because buttercream is soft and delicate. Using a plain edge scraper is a fairly quick way of smoothing your cake. With the cake on a turntable, hold the scraper upright and perpendicular to the work surface, and run it around your cake until smooth ("), _c('a', {
    attrs: {
      "href": "#/Chapter15#F6"
    }
  }, [_vm._v("B")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "F6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("If your cake is tall you may need to use a longer implement, such as a ruler, a big cake lifter or (the most effective tool we’ve found) an L ruler or 90-degree triangle ruler.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F37.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579223e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter15.vue
// module id = 84
// module chunks = 0